const toastConfig = {
    success: {
      style: {
        border: "1px solid #28a745",
        padding: "16px",
        color: "#155724",
        backgroundColor: "#d4edda",
      },
      iconTheme: {
        primary: "#28a745",
        secondary: "#ffffff",
      },
    },
    error: {
      style: {
        border: "1px solid #dc3545",
        padding: "16px",
        color: "#721c24",
        backgroundColor: "#f8d7da",
      },
      iconTheme: {
        primary: "#dc3545",
        secondary: "#ffffff",
      },
    },
    warning: {
      style: {
        border: "1px solid #ffc107",
        padding: "16px",
        color: "#856404",
        backgroundColor: "#fff3cd",
      },
      iconTheme: {
        primary: "#ffc107",
        secondary: "#ffffff",
      },
    },
    info: {
      style: {
        border: "1px solid #17a2b8",
        padding: "16px",
        color: "#0c5460",
        backgroundColor: "#d1ecf1",
      },
      iconTheme: {
        primary: "#17a2b8",
        secondary: "#ffffff",
      },
    },
  };
  
  export default toastConfig;
  